var whatWeDo = whatWeDo || {};

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F()
        }
    })()
}

jQuery(function ( $ ) {

    $.fn.vertSlider = function( options ) {
        return this.each(function() {
            var vertSlider = Object.create(whatWeDo.vertSlider);
            vertSlider.init(this, options);
        });
    };

    $.fn.vertSlider.options = {
     };

    whatWeDo.vertSlider = {


        init (elem, options) {
            var self = this;
            self.$container = $(elem);
            // Slide Elements
            self.$slider = self.$container.find(".vertical-slider")
            self.$slide = self.$slider.find(".vertical-slide")

            self.$isAnimating = false;
            self.$activeNum = 0;
            self.$activeSlide = self.$slide[self.$activeNum];
            self.slideTotal = self.$slide.length - 1;
            self.$mobileView = $(window).width()

            // Dots
            self.$container.append("<ul class='vertical-dots'></ul>")
            self.$dots = self.$container.find(".vertical-dots");

            // Numbers
            self.$container.append("<ul class='vertical-number'></ul>")
            self.$numbers = self.$container.find(".vertical-number");


            self.$lockScroll = true;

            if( self.$mobileView > 1024 ) {
                self.buildSlider();
                self.bindElements();
            }

        },
        killAll() {
            var self = this;
            self.$waypoint1.destroy();
            self.$waypoint2.destroy();
            self.$slider.unbind("mousewheel");
        },
        buildSlider() {
            var self = this;


            $(self.$slide[0]).addClass("active-slide");


            self.$slide.each(function(i,v) {

                self.$dots.append("<li class='vertical-dots__item'><a href='#' data-slideto="+i+" class='vertical-dots__link'><span class='vertical-dots__label'>"+i+"</span></a></li>")

                self.$numbers.append("<li class='vertical-number__item'><a href='#' data-slideto="+i+" class='vertical-number__link'><span class='vertical-number__label'>"+(i+1)+"</span></a></li>")

                $(this).attr("data-slide", i)

            });

            self.$dotLink = self.$dots.find(".vertical-dots__link");
            $(self.$dotLink[0] ).addClass("active-dot")
            self.$numberLink = self.$numbers.find(".vertical-number__link");
            $( self.$numberLink[0] ).addClass("active-number").attr("data-theme", $( self.$activeSlide ).data("theme"))

        },

        bindElements () {
            var self = this;
            self.$waypoint1 = self.$container.waypoint(function(direction) {
                if( direction === "down") {
                    self.$isAnimating = true;
                    self.jackScroll();
                }
            }, {
              offset: '90%'
            });

            self.$waypoint2 = self.$container.waypoint(function(direction) {
                if( direction === "up") {

                    self.$isAnimating = true;
                    self.jackScroll();

                }
            }, {
              offset: '-80%'
            })

            self.$dotLink.on("click", function() {
                var newSlide = $(this).data("slideto");

                self.$isAnimating = true;
                self.showSlide( self.$activeNum , newSlide);
                return false;
            })

            self.$numberLink.on("click", function() {
                var newSlide = $(this).data("slideto");

                self.$isAnimating = true;
                self.showSlide( self.$activeNum , newSlide);

                return false;
            })



        },
        jackScroll() {
            var self = this;
            self.$lockScroll = false;
            self.preventScroll()
            $('html, body').animate({
                    scrollTop: self.$container.offset().top - 60
            }, 500, function() {
                self.setSlider();
                self.$isAnimating = false;
            });

        },
        preventScroll() {

        },
        setSlider( e ) {
            var self = this;


            self.$delta = 0;

            self.$slider.on('mousewheel', function(e) {
                var scrollThreshold = 15;
                if (e.originalEvent.detail < 0 || e.originalEvent.wheelDelta > 0) {
                            self.$delta--;
                            if ( Math.abs(self.$delta) >= scrollThreshold) {
                                self.$delta = 0;
                                !self.$isAnimating && self.prevSlide(self.$activeNum);
                            }
                            return false;
                        }

                        // --- Scrolling down ---
                        else {

                            self.$delta++;
                            if (self.$delta >= scrollThreshold) {
                                self.$delta = 0;
                                !self.$isAnimating && self.nextSlide(self.$activeNum);
                            }
                            return false;
                        }
            });
        },
        nextSlide(currentSlide) {
            var self = this;
            self.$delta = 0;
            if ( self.slideTotal !== currentSlide ) {
                self.$isAnimating = true;
                self.showSlide( currentSlide , currentSlide + 1 )

            } else {
                self.$lockScroll = true;
                self.$slider.unbind("mousewheel");
            }

        },
        prevSlide(currentSlide) {
            var self = this;

            self.$delta = 0;

            if ( self.$activeNum !== 0 ){
                self.showSlide( currentSlide , currentSlide - 1)

            } else {
                self.$activeNum = 0;
                self.$lockScroll = true;
                self.$slider.unbind("mousewheel")
            }

        },

        showSlide( currentSlide, newSlide ) {
            var self = this;

            self.$isAnimating = true;
            self.$activeNum = newSlide ;
            self.$activeSlide = self.$slide[self.$activeNum]

            $( self.$slide[currentSlide] )
                .removeClass("active-slide")
                .addClass("animate-out");

            setTimeout( function() {
                self.$isAnimating = false;
                $( self.$slide[currentSlide] ).removeClass("animate-out")
            }, 1000 );

            $( self.$activeSlide ).addClass("active-slide")

            $( self.$dotLink).removeClass("active-dot");
            $( self.$dotLink[self.$activeNum] ).addClass("active-dot");

            $( self.$numberLink ).removeClass("active-number");
            $( self.$numberLink[newSlide] ).addClass("active-number").attr("data-theme", $( self.$activeSlide ).data("theme"));

            var activeDigit = $( self.$numberLink[newSlide] ).parent().height() * newSlide;

            $(self.$numberLink).parent().css('transform', 'translateY(-' + activeDigit + 'px)');


        }
    }
});
